import { render, staticRenderFns } from "./NsCheckbox.vue?vue&type=template&id=5a26687d&scoped=true&"
import script from "./NsCheckbox.vue?vue&type=script&lang=js&"
export * from "./NsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NsCheckbox.vue?vue&type=style&index=0&id=5a26687d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a26687d",
  null
  
)

export default component.exports